import { AnimationCallbackEvent, Component, computed, inject } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { Venue, VenueCardComponent } from './venue-card/venue-card';
import { AuthService } from '../../../services/auth.service';

export type { Venue } from './venue-card/venue-card';
import gsap from 'gsap';

@Component({
    selector: 'funpay-home',
    templateUrl: './funpay.html',
    imports: [SkeletonModule, VenueCardComponent]
})
export class FunPayHomeComponent {
    auth = inject(AuthService);

    availableClients = computed<Venue[]>(() => {
        return (this.auth.clientsInOrganization() ?? []).filter((client) => !!client?.id && !!client?.settings);
    });

    enterCards(event: AnimationCallbackEvent) {
        gsap.from(event.target.children, {
            y: 10,
            opacity: 0,
            ease: 'power2.in',
            stagger: 0.1
        });
    }
}
